<script>
import BaseUploadCollectorFileModal from '@/components/admin/collector/publications/BaseUploadCollectorFileModal.vue'

export default {
  name: 'UploadCollectorFileModal',
  extends: BaseUploadCollectorFileModal,
}
</script>
